import React, { createContext, useContext, useState, useEffect } from 'react';

const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
    const [adminInfo, setAdminInfo] = useState({
        hospitalId: null,
        hospitalName: null,
        regionCode: null,
        regionName: null,
        districtCode: null,
        districtName: null,
        groupRole: null,
        groupId: null
    });

    // 로컬 스토리지에서 관리자 정보 로드
    useEffect(() => {
        const storedHospitalId = localStorage.getItem('hospital_id');
        const storedHospitalName = localStorage.getItem('hospital_name');
        const storedRegionCode = localStorage.getItem('region_code');
        const storedRegionName = localStorage.getItem('region_name');
        const storedDistrictCode = localStorage.getItem('district_code');
        const storedDistrictName = localStorage.getItem('district_name');
        const storedGroupRole = localStorage.getItem('group_role');
        const storedGroupId = localStorage.getItem('group_id') || '';

        setAdminInfo({
            hospitalId: storedHospitalId || '',
            hospitalName: storedHospitalName || '',
            regionCode: storedRegionCode || '',
            regionName: storedRegionName || '',
            districtCode: storedDistrictCode || '',
            districtName: storedDistrictName || '',
            groupRole: storedGroupRole || '',
            groupId: storedGroupId
        });
    }, []);

    // 관리자 정보 업데이트
    const updateAdminInfo = (info) => {
        setAdminInfo({
            ...info,
            groupId: info.groupId || ''
        });
        // 로컬 스토리지에 저장
        localStorage.setItem('hospital_id', info.hospitalId || '');
        localStorage.setItem('hospital_name', info.hospitalName || '');
        localStorage.setItem('region_code', info.regionCode || '');
        localStorage.setItem('region_name', info.regionName || '');
        localStorage.setItem('district_code', info.districtCode || '');
        localStorage.setItem('district_name', info.districtName || '');
        localStorage.setItem('group_role', info.groupRole || '');
        localStorage.setItem('group_id', info.groupId || '');
    };

    return (
        <AdminContext.Provider value={{ adminInfo, updateAdminInfo }}>
            {children}
        </AdminContext.Provider>
    );
};

export const useAdmin = () => {
    const context = useContext(AdminContext);
    if (!context) {
        throw new Error('useAdmin must be used within an AdminProvider');
    }
    return context;
}; 